import React, { useContext, useState } from "react";
import styles from "./FileCardProgress.module.scss";
import stylesText from "../../components/Text/Text.module.scss";
import PathContext from "../../context/path";
import MobileContext from "../../context/mobile";
import { useRef } from 'react';
import { useEffect } from 'react';
import Counter from '../Counter';
const FileCardProgress = (props) => {
  const { icon, text, img, isProgress, counter, desc } = props;
  const path = useContext(PathContext);
  const isMobile = useContext(MobileContext);
  const refWrap = useRef(null);
  const refImgs = useRef(null);
  const refImgsInner = useRef(null);
  const [progress, setProgress] = useState(0);
  let textElement = [];
  if (text !== undefined && text.length > 0) {
    text.forEach((element, index) => {
      if (index !== text.length - 1) {
        textElement.push(<p className={`${stylesText.lid}`} key={`text-${index}`}>{element}</p>);
      } else {
        textElement.push(<p key={`text-${index}`}>{element}</p>);
      }

    });
  }
  let imgElement = null;
  if (img !== undefined && typeof img === 'string') {
    imgElement = <div className={styles.img}>
      <picture>
            <source media="(min-width: 1921px)" srcSet={`${path}/img/${img}@2x.webp`} />
            <source media="screen and (max-width: 767px)" srcSet={`${path}/img/${img}-mobile.webp, ${path}/img/${img}-mobile@2x.webp 2x`} />
            <img src={`${path}/img/${img}.webp`} srcSet={`${path}/img/${img}@2x.webp 2x`} alt="" />
          </picture>
    </div>
  }
  if (img !== undefined && typeof img === 'object' && img.length > 0) {
    let imgs = [];
    img.forEach((element, index) => {
      imgs.push(
        <div className={styles.img} key={`img-${index}`}>
          <div className={styles.img__info}>
            <div className={styles.img__counter}>
              <Counter start={0} finish={counter[index]} duration={1500} floor={true} />
            </div>
            <div className={styles.img__desc}>
              {desc[index]}
            </div>
          </div>
          <picture>
            <source media="(min-width: 1921px)" srcSet={`${path}/img/${element}@2x.webp`} />
            <source media="screen and (max-width: 767px)" srcSet={`${path}/img/${element}-mobile.webp, ${path}/img/${element}-mobile@2x.webp 2x`} />
            <img src={`${path}/img/${element}.webp`} srcSet={`${path}/img/${element}@2x.webp 2x`} alt="" />
          </picture>
        </div>
      );
    });
    imgElement = <div className={styles.imgs} ref={refImgs}>
      <div className={styles.imgs__inner} ref={refImgsInner}>
        {imgs}
      </div>
    </div>
  }
  useEffect(() => {

    if (refImgs.current !== null && refImgsInner.current !== null) {
      const imgs = refImgs.current;
      const inner = refImgsInner.current;
      if (!isMobile) {
        let innerWidth = inner.offsetHeight;
        let bodyWidth = imgs.offsetHeight;
        let top = (innerWidth - bodyWidth) * progress / 100;
        inner.style.top = -top + 'px';
      }else {
        inner.style.top = '';
      }
    } 
  }, [isMobile, progress]);
  useEffect(() => {
    let options = {
      threshold: 0.0,
      rootMargin: '0% 0% 0% 0%'
    }
    const item = refWrap.current.parentNode;
    const container = refWrap.current.parentNode.parentNode;
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          localProgress();
          document.addEventListener('scroll', localProgress);
        } else {
          localProgress();
          document.removeEventListener('scroll', localProgress);
        }
      })
    }, options);

    const localProgress = () => {
      let currentProgress = 0;
      if (container.getBoundingClientRect().top + item.offsetHeight < 0 && container.getBoundingClientRect().bottom - window.innerHeight > 0) {
        currentProgress = (-(container.getBoundingClientRect().top + item.offsetHeight) / (container.offsetHeight - window.innerHeight - item.offsetHeight)) * 100;
      } else if (container.getBoundingClientRect().top + item.offsetHeight >= 0) {
        currentProgress = 0;
      } else {
        currentProgress = 100;
      }
      setProgress(currentProgress);
    }
    if (isProgress !== undefined && isProgress && !isMobile) {
      if (refWrap.current !== null) {
        observer.observe(item);
      }
    }

    window.addEventListener('resize', localProgress);
    return () => {
      if (isProgress !== undefined && isProgress) {
        observer.unobserve(item);
      }
      observer.unobserve(item);
      document.removeEventListener('scroll', localProgress);
      window.removeEventListener('resize', localProgress);
    }
  }, [isMobile, isProgress]);
  return (
    <>
      <div className={styles.wrap} ref={refWrap}>
        <div className={styles.info}>
          <div className={styles.icon}>
            <img src={`${path}/img/${icon}.svg`} alt="" />
          </div>
          <div className={styles.text}>
            {textElement}
          </div>
        </div>
        {imgElement}
      </div>
    </>
  );

}

export default FileCardProgress;
